import React, { FC } from 'react';
import { IOptions } from '@components/Select/types';
import { useLanguageContext } from '@hooks/useLanguageContext';
import { Info } from '@components/Info';

interface IPatientTrialStepProps {
  trialId: string;
  patientId: string;
  locationId: string;
  contactPhone: string;
  trialOptions: IOptions[];
  patientOptions: IOptions[];
  locationOptions: IOptions[];
  onTrialChange: (value: string) => void;
  onPatientChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  onContactPhoneChange: (value: string) => void;
}

export const PatientTrialStep: FC<IPatientTrialStepProps> = ({
  trialId,
  patientId,
  locationId,
  contactPhone,
  trialOptions,
  patientOptions,
  locationOptions,
  onTrialChange,
  onPatientChange,
  onLocationChange,
  onContactPhoneChange,
}) => {
  const { dictionary } = useLanguageContext();

  return (
    <>
      <section className="form-section">
        <h2 className="form-title title-md is-underlined">
          {dictionary.trials.modals.createTrial.generalInformation}
        </h2>
      </section>
      <section className="form-section">
        <div className="row">
          <div className="col-xs-12">
            <Info text="Select a trial to load its appointment template. All required visits for the trial will be shown in the next step." />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="field">
              <label className="field-label">
                {dictionary.labels.trial}
                <span className="field-required">*</span>
              </label>
              <div className="input">
                <select
                  className="input-control"
                  value={trialId}
                  onChange={(e) => onTrialChange(e.target.value)}
                >
                  <option value="">{dictionary.placeholders.chooseTrial}</option>
                  {trialOptions.map((opt) => (
                    <option key={String(opt.value)} value={String(opt.value)}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="field">
              <label className="field-label">
                {dictionary.labels.patient}
                <span className="field-required">*</span>
              </label>
              <div className="input">
                <select
                  className="input-control"
                  value={patientId}
                  onChange={(e) => onPatientChange(e.target.value)}
                >
                  <option value="">{dictionary.placeholders.choosePatient}</option>
                  {patientOptions.map((opt) => (
                    <option key={String(opt.value)} value={String(opt.value)}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="field">
              <label className="field-label">
                {dictionary.labels.location}
                <span className="field-required">*</span>
              </label>
              <div className="input">
                <select
                  className="input-control"
                  value={locationId}
                  onChange={(e) => onLocationChange(e.target.value)}
                >
                  <option value="">{dictionary.placeholders.chooseLocation}</option>
                  {locationOptions.map((opt) => (
                    <option key={String(opt.value)} value={String(opt.value)}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <div className="field">
              <label className="field-label">{dictionary.labels.physicianPhoneNumber}</label>
              <div className="input">
                <input
                  className="input-control"
                  type="text"
                  value={contactPhone}
                  onChange={(e) => onContactPhoneChange(e.target.value)}
                  placeholder={dictionary.placeholders.phoneMask}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
